import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import { setErrorMessage } from 'utils/index';
import { IFilterType } from 'constants/balance.constants';
import _ from 'lodash';
import { setBenefits, setCompanyBenefits, setError, setLoading } from 'state/reducers/benefits.reducer';
import { IBenefit } from 'constants/benefits.constants';

export function getBenefits() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_BENEFITS, {})
			.then((response: any) => {
				dispatch(setBenefits(_.get(response.data, 'benefits')));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
export function getCompanyBenefitsByCompanyId(companyId: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_COMPANY_BENEFITS, { companyId })
			.then((response: any) => {
				dispatch(setCompanyBenefits(_.get(response.data, 'companyBenefits')));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function createBenefit(benefit: any) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.CREATE_BENEFIT, benefit)
			.then(() => {})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
export function addCompanyBenefit(benefitId: number, companyId: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.ADD_COMPANY_BENEFIT, { benefitId, companyId })
			.then((response: any) => {
				dispatch(setCompanyBenefits(_.get(response.data, 'companyBenefits')));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
export function updateCompanyBenefitStatus(benefitId: number, companyId: string, isActive: boolean) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPDATE_COMPANY_BENEFIT_STATUS, { benefitId, companyId, isActive })
			.then((response: any) => {
				dispatch(setCompanyBenefits(_.get(response.data, 'companyBenefits')));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function updateBenefitStatus({ benefitId, isActive }: { benefitId: number; isActive: boolean }) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPDATE_BENEFIT_STATUS, { benefitId, isActive })
			.then((response: any) => {})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(getBenefits());
			});
	};
}
